"use client";
import styles from "./PageCard.module.scss";
import cn from "clsx";
import Markdown from "@/components/atoms/Markdown";
import { useRouter } from "next/navigation";
import { programListPages } from "@/helpers/constants";

export default function PageCardImmersion({
  BGColor,
  TextColor,
  BorderColor,
  Icon,
  Title,
  Content,
  hasBorder = false,
  SubtitleLabel = "",
  Subtitle,
  imageLoadingStrategy = "eager",
  isOutline,
  fontSizeTitle,
  fontSizeContent,
  fontSizeDescription,
  TitleDescription,
  isLastCard = false,
  Image,
  index,
  isCampusImmersionPage = false,
  isProgramListPage = false,
  isMobile = false,
  totalCards = 0,
}: any) {
  if (!Title?.enabled && !Content?.enabled && !TitleDescription?.enabled) {
    return null;
  }
  let programListTitle: any, programListContent: any;
  if (isProgramListPage) {
    programListTitle = Title?.text?.[0]?.children?.[0]?.text;
    programListContent = Content?.text?.[0]?.children?.[0]?.text;
  }
  const router = useRouter();
  return (
    <div
      id={`pagecard-${index}`}
      className={
        isProgramListPage
          ? styles.announcementItemProgramListContainer
          : styles.announcementCard
      }
    >
      <div
        className={cn(isLastCard ? "" : styles.announcementInner, {
          [styles.border]: hasBorder,
          [styles.bgColor]: BGColor,
          [styles.borderRight]:
            isMobile && isProgramListPage && index !== totalCards - 1,
        })}
      >
        {/* Front Side */}
        <div
          className={
            isProgramListPage
              ? styles.announcementItemProgramList
              : styles.announcementItem
          }
          style={
            isProgramListPage
              ? undefined
              : {
                  borderColor: BGColor || BorderColor,
                  backgroundColor: BGColor,
                }
          }
        >
          {isLastCard ? (
            <div className={cn(styles.Attraction__lastCardImageContainer)}>
              <img
                src={Image?.source?.data?.[0]?.attributes?.url}
                alt={Image?.alt || "Last Card Image"}
                width={300}
                height={200}
                className={cn(styles.Attraction__lastCardImage)}
              />
            </div>
          ) : (
            <>
              {Title?.enabled && (
                <div className={styles.announcementTitle}>
                  <Markdown
                    className={cn(styles.title, {
                      [styles.titleWithSubtitle]: Icon?.source,
                    })}
                    style={{
                      fontSize: isProgramListPage
                        ? isMobile
                          ? "1.5rem"
                          : "2rem"
                        : fontSizeTitle,
                      color: isProgramListPage ? "inherit" : TextColor,
                    }}
                    sanitize={false}
                  >
                    {isProgramListPage ? programListTitle : Title?.text}
                  </Markdown>
                  {TitleDescription?.enabled && (
                    <Markdown
                      as="p"
                      className={styles.titleDescription}
                      style={{ fontSize: fontSizeDescription }}
                      sanitize={false}
                    >
                      {TitleDescription?.text}
                    </Markdown>
                  )}
                </div>
              )}

              {SubtitleLabel && Subtitle ? (
                <div>
                  <div
                    onClick={
                      index === 0 && !isCampusImmersionPage
                        ? () => router.push("/scholarship")
                        : undefined
                    }
                    className={
                      index == 0 && !isCampusImmersionPage
                        ? styles.subtitleRedirect
                        : ""
                    }
                  >
                    <Markdown
                      as="h3"
                      className={cn(
                        "font-semibold",
                        styles.Announcement__subtitleLabel,
                      )}
                      style={{
                        color: TextColor,
                      }}
                      sanitize={false}
                    >
                      {SubtitleLabel.text?.replace(/\n/gi, "  \n")}
                    </Markdown>
                  </div>
                  {Subtitle?.enabled ? (
                    <Markdown
                      as="h3"
                      className="font-bold xl:font-extrabold"
                      style={{
                        color: TextColor,
                      }}
                      sanitize={false}
                    >
                      {Subtitle.text}
                    </Markdown>
                  ) : null}
                </div>
              ) : null}

              {Content?.enabled && (
                <div className={styles.contentParent}>
                  <Markdown
                    className={
                      isProgramListPage
                        ? styles.programListContent
                        : styles.content
                    }
                    style={{ fontSize: fontSizeContent }}
                    sanitize={false}
                  >
                    {isProgramListPage ? programListContent : Content?.text}
                  </Markdown>
                </div>
              )}
            </>
          )}
        </div>
      </div>
    </div>
  );
}
